/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PromisableAction } from "models/promisable-action";

export interface ResetPasswordRequest extends PromisableAction {
    idUsuario: string;
    token: string;
    newPassword: string;
}

interface State {
    isRequesting: boolean;
    errors: string[];
}

const initialState: State = {
    isRequesting: false,
    errors: [],
};

const resetPasswordSlice = createSlice({
    name: "users@resetPassword",
    initialState,
    reducers: {
        resetPasswordRequest: (state, action: PayloadAction<ResetPasswordRequest>): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        resetPasswordSuccess: (state): void => {
            state.isRequesting = false;
        },
        resetPasswordFailed: (state, action: PayloadAction<string[]>): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        },
    },
});

export const { resetPasswordFailed, resetPasswordRequest, resetPasswordSuccess } =
    resetPasswordSlice.actions;

export default resetPasswordSlice.reducer;
